import React from "react";
import style from "./modalPagination.module.scss";
import { LIST_VIEW_LIMIT } from "../../../constants";

export const ModalPagination = ({ activePage, showCount, totalItemsCount, itemsCountPerPage, handleClick }) => {
  const limit = activePage * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 1 : activePage * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT + 1;
  const totalPages = Math.ceil(totalItemsCount / itemsCountPerPage);
  return (
    <div className={`m-2 d-flex justify-content-end align-items-center`}>
      <label className={style.page_show}>{`Showing ${limit} - ${showCount} of ${totalItemsCount}`}</label>

      <nav className={`mt-3 ${totalItemsCount < LIST_VIEW_LIMIT ? "d-none" : ""}`}>
        <ul className="pagination">
          <li className={`mx-1 page-item ${activePage === 1 ? "disabled" : ""}`}>
            <button className={`page-link ${style.icon_color} ${style.selected_bg}`} onClick={() => handleClick(activePage - 1)}>
              <span aria-hidden="true" aria-label="Go to previous page">&laquo;</span>
            </button>
          </li>

          {Array.from({ length: totalPages }, (_, i) => (
            <li key={i} className={`mx-1 page-item ${activePage === i + 1 ? "active" : ""}`}>
              <button
                className={`page-link font-weight-bold ${style.selected_bg} ${activePage === i + 1 ? style.active_bg : style.inactive_bg}`}
                onClick={() => handleClick(i + 1)}
              >
                <span aria-label={`Go to page number ${i + 1}`}>{i + 1}</span>
              </button>
            </li>
          ))}

          <li className={`mx-1 page-item ${activePage === totalPages ? "disabled" : ""}`}>
            <button className={`page-link ${style.selected_bg} ${style.icon_color}`} onClick={() => handleClick(activePage + 1)}>
              <span aria-hidden="true" aria-label="Go to next page">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};
